import { AbstractControl, ValidationErrors } from '@angular/forms';
import { skillMdConfigurationFileValidator } from './assistant-builder-skill-md-config.validators';

export interface GenericAssistantFileLike {
  name: string;
}

export type AssistantBuilderTraitGenericFilesValue = GenericAssistantFileLike[];

export interface AssistantBuilderTraitGenericFormValues {
  sourceFiles: AssistantBuilderTraitGenericFilesValue;
  configurationFile: AssistantBuilderTraitGenericFilesValue;
}

/**
 * Generic-form binding of the shared skill.md group validator (T4): same
 * exactly-one-skill.md semantics as before, plus the case-insensitive
 * near-miss detection shared with the comparison/compliance forms.
 */
export const genericConfigurationFileValidator: (
  group: AbstractControl,
) => ValidationErrors | null = skillMdConfigurationFileValidator(
  'configurationFile',
  ['sourceFiles'],
);
